/**
 * Основні комерційні регіони AWS (без China / GovCloud).
 * Коефіцієнти — грубий орієнтир до us-east-1, не офіційні прайси.
 */
export const AWS_REGION_IDS = [
  "af-south-1",
  "ap-east-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-northeast-3",
  "ap-south-1",
  "ap-south-2",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-southeast-3",
  "ap-southeast-4",
  "ca-central-1",
  "eu-central-1",
  "eu-central-2",
  "eu-north-1",
  "eu-south-1",
  "eu-south-2",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "il-central-1",
  "me-central-1",
  "me-south-1",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
] as const;

export type AwsRegionId = (typeof AWS_REGION_IDS)[number];

const FACTOR: Record<AwsRegionId, number> = {
  "af-south-1": 1.14,
  "ap-east-1": 1.09,
  "ap-northeast-1": 1.11,
  "ap-northeast-2": 1.09,
  "ap-northeast-3": 1.11,
  "ap-south-1": 1.08,
  "ap-south-2": 1.08,
  "ap-southeast-1": 1.08,
  "ap-southeast-2": 1.09,
  "ap-southeast-3": 1.08,
  "ap-southeast-4": 1.09,
  "ca-central-1": 1.04,
  "eu-central-1": 1.05,
  "eu-central-2": 1.07,
  "eu-north-1": 1.04,
  "eu-south-1": 1.06,
  "eu-south-2": 1.06,
  "eu-west-1": 1.03,
  "eu-west-2": 1.05,
  "eu-west-3": 1.05,
  "il-central-1": 1.07,
  "me-central-1": 1.09,
  "me-south-1": 1.11,
  "sa-east-1": 1.22,
  "us-east-1": 1,
  "us-east-2": 1,
  "us-west-1": 1.04,
  "us-west-2": 0.99,
};

const REGION_SET = new Set<string>(AWS_REGION_IDS);

export function awsRegionFactor(id: AwsRegionId): number {
  return FACTOR[id] ?? 1;
}

export function normalizeAwsRegion(x: unknown): AwsRegionId {
  if (typeof x === "string" && REGION_SET.has(x)) return x as AwsRegionId;
  return "us-east-1";
}
